import { inject, ComponentEventBus } from "fw";

@inject
export class ModalHeader {
    constructor(private ceb: ComponentEventBus) {}

    close() {
        this.ceb.dispatch("close");
    }
}
